import React, { useCallback } from "react";
import PropTypes from "prop-types";
import { FormattedMessage } from "react-intl";
import AmountContainer from "app/pages/.shared/AmountContainer";
import AmountSign from "app/pages/.shared/AmountSign/AmountSign";
import Radio from "app/pages/.shared/form/Radio";
import "./CreditRadio.scss";
import PaymentCouponItem from "app/pages/Booking/Payment/PaymentCoupons/PaymentCouponItem/PaymentCouponItem";
import MoreDetails from "app/pages/.shared/MoreDetails";
import { PAYMENT_COUPON_TYPE } from "app/constants";
import { sendTagOnMoreDetailCreditClick } from "app/utils/analytics";

const CreditRadio = ({ field, onChange, value, usableCredits, unusableCredits }) => {
	const handleOnClick = useCallback(() => {
		sendTagOnMoreDetailCreditClick();
	}, []);

	return (
		<Radio
			field={field}
			showIcon={true}
			name="credit-radio"
			id="credit-radio"
			value={PAYMENT_COUPON_TYPE.CREDIT}
			checked={field.value === PAYMENT_COUPON_TYPE.CREDIT}
			toggle={() => {
				onChange(PAYMENT_COUPON_TYPE.CREDIT);
			}}
			data-cy={`coupon-credit-input`}
			body={
				<div className="credit-radio__body">
					<MoreDetails
						headerPosition={"bottom"}
						expandedLabel={<FormattedMessage id="product.page.less.details" />}
						collapsedLabel={<FormattedMessage id="product.page.more.details" />}
						onChange={handleOnClick}
					>
						{usableCredits.map(usableCredit => {
							return (
								<div className="credit-radio__coupon-item" key={usableCredit.title}>
									<PaymentCouponItem
										friendEmail={usableCredit.friendEmail}
										source={usableCredit.source}
										amount={usableCredit.amount}
										creationDate={usableCredit.creationDate}
										balance={usableCredit.balance}
										uses={usableCredit.uses}
										maxUseDate={usableCredit.maxUseDate}
										conditions={usableCredit.conditions}
										usageRule={
											<FormattedMessage id="payment.coupons.credit.usage.rule" />
										}
										title={usableCredit.title}
										usableAmount={usableCredit.usableAmount}
									/>
								</div>
							);
						})}

						{unusableCredits.map(unusableCredit => {
							return (
								<div
									className="credit-radio__coupon-item"
									key={unusableCredit.title}
								>
									<PaymentCouponItem
										disabled={true}
										friendEmail={unusableCredit.friendEmail}
										source={unusableCredit.source}
										isApplicable={unusableCredit.isApplicable}
										amount={unusableCredit.amount}
										creationDate={unusableCredit.creationDate}
										balance={unusableCredit.balance}
										uses={unusableCredit.uses}
										maxUseDate={unusableCredit.maxUseDate}
										conditions={unusableCredit.conditions}
										title={unusableCredit.title}
										usableAmount={unusableCredit.usableAmount}
									/>
								</div>
							);
						})}
					</MoreDetails>
				</div>
			}
		>
			<div className="credit-radio__content">
				<div className="credit-radio__name">
					<FormattedMessage id="payment.coupons.input.credits.label" />
				</div>
				<div className="credit-radio__amount">
					<AmountContainer amount={value} prefix={<AmountSign sign="-" />} />
				</div>
			</div>
		</Radio>
	);
};

CreditRadio.propTypes = {
	field: PropTypes.object,
	onChange: PropTypes.func,
	value: PropTypes.number,
	usableCredits: PropTypes.array,
	unusableCredits: PropTypes.array,
};

CreditRadio.defaultProps = {
	field: {},
	usableCredits: [],
	unusableCredits: [],
	onChange: () => {},
};

export default CreditRadio;
